export enum PlayerActionTypes {
  GET_RANK_DETAILS = '@player/GET_RANK_DETAILS',
  GET_TOKEN_DETAILS = '@player/GET_TOKEN_DETAILS',
  GET_GAMIFICATION_OPT_STATUS = '@player/GET_GAMIFICATION_OPT_STATUS',
  SET_GAMIFICATION_OPT_STATUS = '@player/SET_GAMIFICATION_OPT_STATUS',
  CLAIM_PLAYER_REWARDS = '@player/CLAIM_PLAYER_REWARDS',
}
